import { Component, Input } from '@angular/core';
import { RoleMatrix } from 'src/helpers';

@Component({
    selector: 'app-breadcumb-work-order-configuration',
    templateUrl: './breadcumb-work-order-configuration.component.html'
})
export class BreadcrumbWorkOrderConfigurationComponent {
    @Input() companyId: number;
    roleMatrix: RoleMatrix;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
